import React from 'react'

function ConditionsForContributorsIT() {
  return (
    <>
      <p className="heading-1">
        Termini e Condizioni d'uso (T&C) Skeepers Influence
      </p>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">1. Oggetto</p>
        <p>
          I Termini e Condizioni d'uso qui presenti (di seguito denominati
          "T&C") hanno lo scopo di disciplinare l'utilizzo del sito{' '}
          <a
            href="http://app.im.skeepers.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://app.im.skeepers.io/
          </a>{' '}
          pubblicato da Skeepers nonché i termini e le condizioni in base a cui
          vengono forniti i vari servizi offerti sul sito sopra citato. La
          navigazione sul Sito come di seguito definito implica automaticamente
          l'accettazione espressa e senza riserve da parte del Creator delle
          presenti Condizioni.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Definizioni</p>
        <p>
          Ai seguenti termini in maiuscolo viene assegnato il significato come
          di seguito:
        </p>
        <div className="definition">
          <p>Cliente</p>
          <p>
            Si riferisce alla società, al produttore o all'entità che
            commercializza il prodotto/servizio con un marchio, oggetto del
            Contenuto
          </p>
        </div>
        <div className="definition">
          <p>Contenuto</p>
          <p>
            Si riferisce ai testi, alle immagini, alle fotografie, ai disegni,
            agli avatar e più in generale a qualsiasi pubblicazione visiva,
            testuale, sonora o grafica del Creator, rappresentativa dei Prodotti
            proposti nell'ambito dei Servizi
          </p>
        </div>
        <div className="definition">
          <p>Creator</p>
          <p>
            Persona precedentemente registrata che accede alla piattaforma
            Skeepers allo scopo di generare Contenuti. (IM e CV)
          </p>
        </div>
        <div className="definition">
          <p>Identificativi</p>
          <p>
            Si riferisce al nome Creator e alla password che consentono
            all'Creator di accedere al Sito
          </p>
        </div>
        <div className="definition">
          <p>Influenceur</p>
          <p>
            Creator che ha ricevuto gratuitamente un prodotto per poter
            pubblicare un Contenuto dedicato sul proprio social network (ad
            esempio, Instagram, TikTok, YouTube, Pinterest, Blog, ecc.).
          </p>
        </div>
        <div className="definition">
          <p>Prodotti</p>
          <p>
            Si riferisce ai prodotti e servizi commercializzati dal Cliente{' '}
          </p>
        </div>
        <div className="definition">
          <p>Profilo</p>
          <p>
            Si riferisce all'interfaccia presente sul Sito dedicata all'Creator
          </p>
        </div>
        <div className="definition">
          <p>Servizi</p>
          <p>Si riferisce ai servizi forniti da Skeepers</p>
        </div>
        <div className="definition">
          <p>Skeepers</p>
          <p>
            Si riferisce all’entità giuridica identificata nelle Note Legali del
            Sito
          </p>
        </div>
        <div className="definition">
          <p>Sito</p>
          <p>
            Si riferisce al sito web accessibile all'indirizzo{' '}
            <a
              href="http://app.im.skeepers.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://app.im.skeepers.io/
            </a>{' '}
          </p>
        </div>
        <div className="definition">
          <p>Social (Network)</p>
          <p>
            Indica tutti i social (network) presenti o futuri i cui Contenuti
            possono essere oggetto dei Servizi Skeepers, quali, a titolo
            esemplificativo: YouTube, Instagram, Facebook, Twitter, Twitch,
            Blog, TikTok, Pinterest
          </p>
        </div>
        <div className="definition">
          <p>T&C</p>
          <p>Si riferisce ai presenti termini e condizioni generali d'uso</p>
        </div>
        <div className="definition">
          <p>Tester</p>
          <p>
            Creator che ha ricevuto un prodotto gratuitamente per creare una
            recensione video (CV) o testuale (IM), che sarà pubblicata sul sito
            di e-commerce del Cliente e/o dei suoi partner.
          </p>
        </div>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">3. Descrizione dei servizi </p>
        <p>Skeepers offre agli Utenti i seguenti Servizi:</p>
        <ul className="paragraph-2">
          <li>
            Accesso al Sito da parte degli Utenti (inclusa la visualizzazione di
            statistiche, corrispondenze e abbinamenti con Prodotti e Clienti)
          </li>
          <li>Invio di Prodotti e/o relativi vantaggi.</li>
        </ul>
        <p>
          I servizi offerti da Skeepers sono offerti gratuitamente agli utenti.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">4. Accesso ai Servizi</p>
        <p>
          Skeepers non garantisce che il Sito sarà accessibile in modo continuo.
          Skeepers si riserva il diritto di modificare, sospendere e/o eliminare
          tutto o parte del Sito e le informazioni in esso contenute in
          qualsiasi momento senza preavviso. Di conseguenza, Skeepers non può
          essere ritenuta responsabile per eventuali danni provati o presunti,
          subiti direttamente o indirettamente, da qualsiasi Creator, relativi
          alla connessione, alla consultazione e/o all'utilizzo delle
          informazioni fornite dal Sito.
        </p>
        <p>
          Per accedere ai Servizi, gli Utenti devono connettersi al Sito con i
          propri Identificativi e alle condizioni descritte di seguito.
        </p>
        <p>
          In generale, qualsiasi violazione delle disposizioni dei presenti
          Termini può comportare, immediatamente e senza preavviso, la
          cancellazione o la sospensione dell'account del Creator, nonostante e
          oltre ogni richiesta di risarcimento danni da parte di Skeepers.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          5. Account personale Skeepers{' '}
        </p>
        <p className="tc-neutral900 ml-16">1/ Registrazione</p>
        <p>
          La registrazione al Sito ai fini della creazione di un account
          personale avviene tramite l'interfaccia dedicata agli Utenti sul Sito,
          tramite la compilazione di tutte le informazioni identificate come
          obbligatorie. L'Creator può anche fornire informazioni facoltative,
          quali, senza che questo elenco sia esaustivo: i suoi brand preferiti,
          i suoi interessi, ecc..
        </p>
        <p>
          Skeepers si riserva il diritto di rifiutare qualsiasi registrazione
          incompleta o non conforme.
        </p>
        <p>L'Creator garantisce a Skeepers di:</p>
        <ul className="paragraph-2">
          <li>
            Avere almeno sedici (16) anni. Se non ha raggiunto la maggiore età
            nel suo Paese di residenza, deve ottenere il consenso dei genitori
            per creare un account personale sul Sito
          </li>
          <li>
            Non essere un ex o attuale dipendente di Skeepers e non lavorare per
            un'agenzia di media o un'agenzia pubblicitaria partner di Skeepers
          </li>
        </ul>
        <p>
          In quanto Influencer, l'Creator deve avere almeno un account su un
          Social Network disponibile in modalità pubblica e che abbia un numero
          minimo di follower (questo è specificato per ogni Social Network
          coinvolto sul Sito dopo la registrazione); ciò vale per tutta la
          durata della sua registrazione sul Sito.
        </p>
        <p>
          Skeepers si riserva il diritto, in qualsiasi momento e per tutta la
          durata della registrazione, di verificare che l'account di social
          network dell'Influencer soddisfi i criteri sopra menzionati. Nel caso
          in cui l'account del social network non soddisfi più uno dei criteri
          sopra menzionati, Skeepers si riserva il diritto di disattivare e/o
          chiudere l'account personale del Creator sul sito.
        </p>
        <p>
          L'Creator si impegna a non aumentare artificialmente automaticamente
          e/o manualmente, da solo o attraverso terzi, il numero di
          visualizzazioni, impressioni e/o clic associati ai Contenuti
          pubblicati sul proprio Account di Social Network, né a incoraggiare
          altri a farlo.
        </p>
        <p>
          L'Creator garantisce che le informazioni fornite per la creazione del
          proprio account sono accurate, sincere e personali. L'Creator si
          impegna ad aggiornare regolarmente i propri dati al fine di informare
          Skeepers sul proprio profilo personale e di beneficiare dei Servizi
          più appropriati messi a disposizione da Skeepers. Skeepers si riserva
          il diritto di eliminare qualsiasi account le cui informazioni sono, in
          particolare, errate o il cui indirizzo, incluso l'indirizzo postale,
          non consentirebbe l'invio e il normale utilizzo dei Prodotti. La
          registrazione del Creator porta automaticamente alla creazione di un
          account e di un profilo a nome del nickname utilizzato sui social
          network, nonché di uno spazio di informazioni relative all'Creator
          accessibile in particolare ai Clienti in caso di abbinamento.
        </p>

        <p className="tc-neutral900 ml-16">2/ L'account personale</p>
        <p>
           Dopo essersi registrato sul Sito come sopra descritto, l'Creator
          finalizza la creazione del proprio account inserendo i propri
          Identificativi, che potrà ancora modificare, sul proprio account.
          L'account è accessibile alle stesse condizioni del Sito. Gli
          Identificativi sono personali e non possono, pena la sospensione o la
          cancellazione dell'account, essere comunicati o sfruttati da terzi.
          Qualsiasi sospetto di divulgazione, intenzionale o meno, di
          identificativi e password impegna la sola e personale responsabilità
          del Creator. In nessun caso Skeepers sarà responsabile per qualsiasi
          uso illecito o fraudolento di nomi Creator e password, nonché dei vari
          strumenti messi a disposizione del Creator.
        </p>
        <p>
          L'Creator può inoltre visualizzare sul proprio account crediti,
          Prodotti ordinati, in corso, Contenuti in corso e precedenti.
        </p>
        <p>
          La creazione di un account personale non dà automaticamente diritto
          all'Creator al beneficio di tutti i Servizi e non garantisce un
          ”abbinamento” con i Prodotti, riservando a Skeepers la scelta dei
          Consumatori beneficiari dei Prodotti e al Cliente quella degli
          Influencer che beneficiano dei Prodotti.
        </p>
        <p>
          L'Creator può richiedere a Skeepers di chiudere il proprio account in
          qualsiasi momento con sufficiente preavviso scritto (è sufficiente
          l'e-mail) di quindici (15) giorni a Skeepers.
        </p>

        <p className="tc-neutral900 ml-16">3/ Il Profilo</p>
        <p>
          La creazione dell'account Skeepers sul Sito genera la creazione di un
          Profilo atto a identificare l'Creator e consentirgli di beneficiare
          dei Servizi. Unavolta creato il Profilo Personale, l'Creator viene
          identificato sul Sito dallo pseudonimo e dall'avatar che utilizza sui
          social network e citati dall'Creator sul Sito. Il Profilo contiene
          anche i precedenti Contenuti caricati automaticamente sul Sito, ai
          quali l'Creator acconsente.
        </p>
        <p>
          A seconda delle informazioni fornite dall'Creator in fase di
          registrazione, il suo Profilo potrebbe corrispondere ai Prodotti. In
          tale eventualità, è quindi possibile l'abbinamento tra l'Creator e i
          Prodotti. Tuttavia, Skeepers si riserva il diritto di limitare questa
          corrispondenza in base ai propri criteri di selezione.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">6. Utilizzo dei Servizi</p>
        <p className="tc-neutral900 ml-16">
          1/ Ordini di prodotti e pubblicazione di contenuti
        </p>
        <p>
          Sul suo account, l'Creator può visualizzare i Prodotti offerti dai
          Clienti suscettibili di "corrispondere" con il suo Profilo. Le
          informazioni relative al prezzo dei Prodotti e le condizioni da
          rispettare per diffondere i Contenuti ad essi riferibili (ad esempio,
          senza che tale elenco sia esaustivo: menzionare il Cliente, aggiungere
          un hashtag, ecc.) sono specificate anch’esse dal Cliente nella
          descrizione dei Prodotti.
        </p>
        <p>
          Se un'offerta soddisfa l'Creator, questi può selezionare la scheda
          "Ordine" per ricevere il Prodotto. Prima di confermare l'ordine, dovrà
          spuntare una casella per specificare di aver preso visione delle
          condizioni relative ai Contenuti che dovrà pubblicare.
        </p>
        <p>
          Dopo aver confermato l'ordine, l'Creator riceve il Prodotto
          gratuitamente (direttamente dal Cliente o da Skeepers).
        </p>
        <p>
          Una volta che il Prodotto è stato ricevuto e testato, l'Creator crea
          Contenuti rispettando le condizioni stabilite dal Cliente nella
          descrizione del Prodotto precedentemente accettata.
        </p>
        <p>
          L'Influencer condivide il link dei suoi Contenuti sul Sito entro
          un'ora dalla pubblicazione degli stessi Contenuti sui Social Network.
          Il Contenuto deve essere pubblicato in "modalità pubblica" e deve
          rimanere accessibile per almeno trenta (30) giorni dalla sua
          pubblicazione sui suoi Social Network, a meno che non vi sia un
          cambiamento di opinione in merito al Prodotto che deve essere prima
          notificato via e-mail a Skeepers.
        </p>
        <p>
          L'Creator seleziona quindi una casella per accettare l'Accordo di
          cessione dei diritti (Accordo della community di Skeepers).
        </p>
        <p>
          Skeepers si riserva il diritto di monitorare il Contenuto quando
          l'Creator lo pubblica sul Sito al fine di verificarne la conformità
          alle condizioni stabilite dal Cliente da un lato, e ai T&C di Skeepers
          e all'Accordo di cessione dei diritti dall'altro.
        </p>
        <p>
          Nel caso in cui il Contenuto non sia conforme, esso non può essere
          diffuso sul Sito. Inoltre, Skeepers può (i) notificare all'Creator
          tale non conformità e richiedere che vengano apportate le modifiche
          necessarie affinché il Contenuto sia conforme ai termini stabiliti dal
          Cliente, ai Termini e Condizioni d’uso di Skeepers e all'Accordo di
          cessione dei diritti e/o (ii) disabilitare e/o chiudere l'account del
          Creator.
        </p>
        <p>
          Per quanto riguarda le recensioni scritte dei consumatori, il Tester
          scrive il suo Contenuto sul Sito e, una volta convalidato da Skeepers,
          l'Creator copia il Contenuto sul sito del Cliente entro un'ora dalla
          convalida.
        </p>

        <p className="tc-neutral900 ml-16">
          2/ Immagine del Cliente e dei Prodotti
        </p>
        <p>
          Il corrispettivo dei Servizi e in particolare la ricezione dei
          Prodotti risiede nell'obbligo che ha l'Creator di pubblicare Contenuti
          che rispettino le condizioni preventivamente accettate e stabilite dal
          Cliente. In caso contrario, Skeepers si riserva il diritto di limitare
          o sospendere l'accesso ai propri Servizi o di eliminare gli
          identificativi.
        </p>
        <p>
          L'Creator si impegna a rispettare i Prodotti e l'immagine del brand
          del Cliente. Pertanto, l'Creator si impegna, in ogni circostanza, a:
        </p>
        <ul className="paragraph-2">
          <li>
            Rispettare le leggi e i regolamenti vigenti applicabili ai Clienti e
            ai Prodotti e non violare i diritti di terzi o l'ordine pubblico
          </li>
          <li>
            Non rivendere o trarre profitto, in alcun modo, dai Prodotti
            ottenuti, per un periodo minimo di 2 anni dal ricevimento o
            dall'accesso al Prodotto
          </li>
          <li>
            Non ricevere denaro e/o altro corrispettivo per valutare i Prodotti
            (salvo diversa indicazione da parte di Skeepers) e non contattare i
            Clienti se non per valutare i loro Prodotti come previsto nel
            presente documento
          </li>
          <li>
            Agire, comunicare, esprimersi e scrivere riguardo al Cliente e/o ai
            Prodotti con discernimento, cortesia e rispetto altrui nei commenti,
            apprezzamenti, in ogni corrispondenza che potrà scrivere e che sarà
            diffusa sui social network 
          </li>
          <li>
            Collaborare con Skeepers fornendole tutte le informazioni necessarie
            per il corretto svolgimento dei Servizi
          </li>
          <li>
            Rispettare le condizioni previste dal Cliente nella descrizione del
            Prodotto sul Sito
          </li>
          <li>
            Indicare che si tratta di contenuti in collaborazione con un brand,
            a condizione che il Contenuto o la relazione con il Cliente rientri
            nei criteri di pubblicità digitale o comunicazione commerciale
            definiti dall’ARPP.
          </li>
        </ul>
        <p>
          Di conseguenza, all'Creator è quindi vietato diffondere, in
          particolare, e senza che tale elenco sia esaustivo:
        </p>
        <ul className="paragraph-2">
          <li>
            Contenuti pornografici, osceni, indecenti, offensivi o inadatti a un
            pubblico familiare, diffamatori, offensivi, violenti, razzisti,
            xenofobi o revisionisti
          </li>
          <li>Contenuti illeciti,</li>
          <li>Contenuti lesivi dell'immagine di terzi,</li>
          <li>
            Contenuti falsi, fuorvianti o che offrono o promuovono attività
            illecite, fraudolente o fuorvianti, Contenuti dannosi per i sistemi
            informatici di terzi (come virus, worm, cavalli di Troia, ecc.) e
          </li>
          <li>
            più in generale, Contenuti che potrebbero violare i diritti di
            terzi, essere dannosi per terzi o impegnare la responsabilità di
            Skeepers o del Cliente in qualsiasi modo e in qualsiasi forma. A tal
            fine, l'Creator si impegna in particolare a non menzionare o
            rappresentare alcun marchio, logo, anche su abbigliamento, diverso
            dai marchi dei Prodotti inviati dal Cliente. Allo stesso modo,
            l'Creator si impegna a utilizzare solo musica royalty-free nei suoi
            Contenuti. L'Creator si impegna inoltre a non includere o mostrare
            bambini che non siano i propri; o qualsiasi adulto che non sappia o
            che non avrebbe acconsentito alla pubblicazione del video.
          </li>
        </ul>
        <p>
          Qualora il Contenuto o il rapporto con il Cliente rientri nei criteri
          di pubblicità digitale o comunicazione commerciale definiti dall'AGCM,
          o qualora il Cliente lo richieda, l'Creator deve includere in ciascun
          Contenuto una dichiarazione chiara e inequivocabile di aver ricevuto i
          Prodotti valutati gratuitamente dal Cliente tramite Skeepers,
          includendo:
        </p>
        <ul className="paragraph-2">
          <li>
            Su YouTube:
            <ul className="paragraph-2">
              <li>
                All'inizio del video: un discorso orale facilmente udibile e
                comprensibile per l'Creator - soprattutto che sia abbastanza
                lento e con parole che saranno comprese dal pubblico. Se il
                video dura più di dieci minuti, l'Creator deve ripetere il
                discorso alla fine del video
              </li>
              <li>
                Nella sezione "A proposito di": un testo esplicativo chiaro e
                inequivocabile.
              </li>
            </ul>
          </li>
          <li>
            Su Instagram :
            <ul className="paragraph-2">
              <li>
                Se il Contenuto è una foto: un testo chiaro e inequivocabile
                disponibile nelle prime tre righe della descrizione della foto
              </li>
              <li>
                Se il Contenuto è una Storia: un hashtag chiaro e inequivocabile
                trasmesso in ogni Storia.
              </li>
            </ul>
          </li>
          <li>
            Sul sito web del Cliente: un testo chiaro e inequivocabile
            disponibile nelle prime tre righe del commento del Creator relativo
            al prodotto del Cliente.
          </li>
          <li>
            Il Contenuto deve riflettere l'opinione onesta e l'esperienza
            personale del Creator, basata sul suo effettivo utilizzo del
            Prodotto. L'Creator si impegna a informare immediatamente Skeepers
            di aver cambiato opinione su tale Prodotto e a rimuovere
            immediatamente il Contenuto corrispondente.
          </li>
          <li>
            L'Creator si impegna a non fare alcuna dichiarazione scientifica o
            prestazionale relativa al Prodotto (come "riduce le rughe!" o "mi
            idrata tutto il giorno!"). L'Creator deve concentrarsi su ciò che
            gli piace o non gli piace del Prodotto, dal suo proprio punto di
            vista personale.
          </li>
        </ul>
        <p>
          Qualsiasi violazione delle disposizioni del presente articolo e più in
          generale dei presenti T&C può comportare, immediatamente e senza
          preavviso, la cancellazione o la sospensione dell'account del Creator,
          nonostante e oltre qualsiasi richiesta di risarcimento danni da parte
          di Skeepers.
        </p>
        <p>
          Inoltre, Skeepers e/o il Cliente possono anche richiedere all'Creator
          di rimuovere il Contenuto pertinente in caso di mancato rispetto delle
          regole e dei principi sopra stabiliti, cosa che l'Creator si impegna a
          fare senza indugio al ricevimento della richiesta.
        </p>
        <p>
          Qualsiasi Prodotto ricevuto è strettamente riservato all'uso personale
          del Creator. All'Creator è vietato venderlo. L'Creator può cedere e/o
          offrire il Prodotto a terzi solo dopo averli testati e dopo aver
          pubblicato un Contenuto in conformità alle presenti Condizioni.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          7. Cessione dei diritti di utilizzo dei Contenuti e autorizzazione dei
          diritti di immagine
        </p>
        <p>
          La pubblicazione del Contenuto sul Sito da parte del Creator
          comporterà contemporaneamente la conclusione da parte del Creator e di
          Skeepers di un Contratto per la cessione dei diritti sul Contenuto
          ("Accordo della Community Skeepers") creato dall'Creator nonché la
          cessione dei suoi diritti sull'immagine accessibile dal seguente link:{' '}
          <a
            href="https://app.im.skeepers.io/community-agreement"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/community-agreement
          </a>
        </p>
        <p>
          In caso di rifiuto del Creator di sottoscrivere detto Contratto di
          cessione dei diritti, lo stesso non potrà pubblicare il proprio
          Contenuto e dovrà restituire al mittente il Prodotto ricevuto.
        </p>
        <p>
          La recensione del cliente scritta del Creator è simile a un’opinione,
          sempre relativa a un'esperienza di consumo ed è pura informazione per
          i futuri consumatori. Pertanto, Skeepers e i suoi partner possono
          liberamente utilizzare, riprodurre, pubblicare, rendere disponibile e
          tradurre il contenuto delle recensioni dei clienti in tutto il mondo e
          su qualsiasi mezzo e media.
        </p>
        <p>
          L'Creator non rileva, il giorno dell'accettazione dei presenti Termini
          & Condizioni, alcuna riluttanza o riserva alle disposizioni del
          presente articolo. Riconosce espressamente che, se non sarà disposto a
          firmare tale Accordo di cessione dei diritti, si asterrà dall'ordinare
          un Prodotto sul Sito poiché l'assenza di cessione dei diritti di
          proprietà intellettuale e dei diritti di immagine collegati al
          Contenuto costituirebbe una perdita di tempo per Skeepers.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">8. Download di Contenuti</p>
        <p>
          Il Cliente può scaricare il Contenuto in questione su base non
          esclusiva al fine di riprodurlo, rappresentarlo e sublicenziarlo e, in
          particolare, includerlo su qualsiasi supporto. Il Cliente beneficia
          inoltre dell'autorizzazione all'utilizzo delle immagini delle persone
          rappresentate in tali Contenuti identificati al momento della sua
          richiesta. I suddetti diritti sono assegnati dall'Creator a Skeepers
          tramite il suddetto Accordo di cessione dei diritti. Skeepers concede
          tali diritti al Cliente attraverso la concessione di una licenza non
          esclusiva.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">9. Garantie</p>
        <p>
          L'Creator dichiara e garantisce di detenere il Contenuto (inclusi i
          diritti ad esso collegati, come i diritti di immagine) in piena
          proprietà e/o che l'Creator ha tutti i diritti e le autorizzazioni
          necessarie per lo sfruttamento e la diffusione del Contenuto e che non
          esiste alcun accordo o diritto che possa impedire tale garanzia,
          l'assegnazione o l'autorizzazione all'utilizzo dell'immagine e del
          Contenuto.
        </p>
        <p>
          Nei casi in cui si applichi la legge n. 2020-1266 del 19 ottobre 2020
          per regolare lo sfruttamento commerciale dell'immagine dei minori di
          sedici anni sulle piattaforme online e i suoi successivi decreti
          attuativi, i rappresentanti legali dei minori di sedici anni sono
          tenuti a richiedere la necessaria approvazione all'autorità
          amministrativa competente. Skeepers non sarà responsabile per il
          mancato ottenimento di tale approvazione da parte del rappresentante
          legale. Il Cliente potrà, in qualsiasi momento, richiedere di
          verificare l'approvazione rilasciata ai legali rappresentanti che
          dovranno quindi comunicarla al momento della prima richiesta. A tal
          proposito, le formalità da rispettare sono dettagliate sul sito
          ufficiale dell'amministrazione francese.
        </p>
        <p>
          L'Creator garantisce inoltre che tale Contenuto non viola l'ordine
          pubblico, la morale o i diritti di terzi, non viola alcuna
          disposizione legislativa o regolamentare e, più in generale, non potrà
          in alcun modo fare appello alla responsabilità civile o penale di
          Skeepers o del Cliente.
        </p>
        <p>
          Come risultato di quanto sopra, l'Creator garantisce Skeepers e il
          Cliente contro qualsiasi azione, reclamo, richiesta, sfratto di
          qualsiasi tipo, da parte di chiunque invochi il mancato rispetto delle
          normative applicabili, un diritto di proprietà intellettuale, che il
          Contenuto potrebbe violare o avrebbe violato, un atto di concorrenza
          sleale e / o parassitaria, violazione dell'ordine pubblico, moralità o
          diritti di terzi e in particolare vietare o limitare il loro uso e
          indennizzare Skeepers e il Cliente da ogni conseguenza derivante da
          una violazione della presente garanzia (comprese eventuali perdite,
          danni, spese e / o costi inclusi, senza limitazione, costi legali e
          spese legali).
        </p>
        <p>
          Skeepers non monitora il Sito, ma si riserva il diritto di rimuovere
          qualsiasi Contenuto che violi i Termini di servizio o non sia conforme
          alla legge applicabile, incluso quello che violi un diritto di
          proprietà intellettuale, qualora venisse a conoscenza dell'illegalità
          di tale Contenuto. A tal fine, ciascun Creator contatterà Skeepers se
          ritiene che un Contenuto violi uno dei suoi diritti e/o la legge
          applicabile e seguendo la procedura imposta dalla legge in materia di
          richieste di rimozione di contenuti illegali. Al ricevimento di una
          richiesta di rimozione valida ai sensi della legge applicabile,
          Skeepers rimuoverà tempestivamente il Contenuto coperto da tale
          richiesta dal Sito.
        </p>
        <p>
          L'Creator deve valutare e sostenere i rischi associati all'uso di
          qualsiasi Contenuto, inclusa l'accuratezza, la completezza o l'utilità
          di tale Contenuto.
        </p>
        <p>
          L'Creator riconosce e accetta che eventuali domande, commenti,
          suggerimenti, idee, impressioni o altre informazioni sui Servizi (qui
          di seguito "Proposte"), che l'Creator fornisce a Skeepers, non sono
          confidenziali e che Skeepers ha il diritto di utilizzarli e
          diffonderli, senza restrizioni, per qualsiasi scopo, commerciale o di
          altro tipo, senza alcun riconoscimento o compenso di alcun tipo a
          beneficio del Creator.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">10. Protezione dei dati</p>
        <p>
          Nel corso delle sue attività e della fornitura dei Servizi, Skeepers
          tratta i dati personali degli Utenti in conformità alla legge
          applicabile. I vari trattamenti effettuati e i diritti degli Utenti
          sono descritti nell'informativa sulla privacy di Skeepers, accessibile
          sul sito Web dal seguente link:{' '}
          <a
            href="https://app.im.skeepers.io/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/privacy
          </a>
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">11. Cookie</p>
        <p>
          Durante la consultazione del Sito, alcuni cookie possono essere
          inseriti sul computer, sul cellulare o sul tablet del Creator.
          L'utilizzo di determinati cookie richiede il preventivo consenso del
          Creator. L'Creator troverà le informazioni specifiche sui cookie
          utilizzati sul sito cliccando qui:{' '}
          <a
            href="https://app.im.skeepers.io/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/privacy
          </a>
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          12. Proprietà intellettuale degli elementi del Sito
        </p>
        <p>
          Ogni elemento pubblicato sul Sito come suoni, immagini, fotografie,
          video, scritti, animazioni, programmi, carta grafica, utilità,
          database, software e altre tecnologie sottostanti, è protetto dalle
          disposizioni del Codice della proprietà intellettuale, appartiene a
          Skeepers o è oggetto di una licenza concessa a Skeepers. Qualsiasi
          segno distintivo che appaia sul Sito, inclusi nomi di società, marchi
          e loghi, sono marchi di proprietà di Skeepers o di terzi o partner,
          inclusi i Clienti le cui offerte sono presentate sul Sito. Ogni
          riproduzione totale o parziale, modifica o utilizzo di tali marchi,
          illustrazioni, immagini e loghi, per qualsiasi motivo e su qualsiasi
          supporto, senza l'espresso consenso preventivo della titolarità dei
          diritti è severamente vietata e costituirebbe una violazione punibile
          dal Codice della Proprietà Intellettuale. L'Creator si impegna a
          utilizzare il Sito e il suo contenuto in un ambiente strettamente
          privato. L'uso commerciale è severamente vietato. L'Creator richiede
          l'autorizzazione preventiva di Skeepers per qualsiasi riproduzione,
          pubblicazione, copia dei vari contenuti.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">13. Riferimenti e link</p>
        <p>
          All'Creator sono messi a disposizione collegamenti ipertestuali
          riferiti a siti partner o siti di terze parti. Nella misura in cui
          Skeepers non può controllare tali siti, essa non sarà responsabile
          circa le informazioni ivi contenute. Skeepers non sarà responsabile
          per eventuali modifiche o aggiornamenti dei suddetti siti o per
          eventuali malfunzionamenti degli stessi. Skeepers non può in alcun
          modo essere ritenuta responsabile per danni diretti o indiretti
          relativi alla navigazione o al download su collegamenti ipertestuali
          pubblicati sul sito Web.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">14. Responsabilità</p>
        <p>
          L'utilizzo del Sito implica la conoscenza e l'accettazione da parte
          del Creator delle caratteristiche e dei limiti di Internet e delle
          tecnologie correlate. Skeepers non può essere ritenuta responsabile
          per eventuali danni derivanti da una connessione al Sito che l'Creator
          effettua sotto la sua esclusiva responsabilità. Pertanto, Skeepers
          declina ogni responsabilità in particolare in caso di uso improprio o
          incidente relativo all'uso del dispositivo per connettersi al Sito,
          all'accesso a Internet, alla manutenzione o al malfunzionamento dei
          server, della linea telefonica o di qualsiasi altra connessione
          tecnica e all'invio di moduli a un indirizzo errato o incompleto,
          eventuali errori informatici o difetti riscontrati sul Sito. Inoltre,
          Skeepers si impegna a fornire informazioni accurate e aggiornate sul
          Sito. Tuttavia, Skeepers non sarà responsabile di eventuali
          inesattezze o omissioni sul proprio Sito.
        </p>
        <p>
          Skeepers sarà responsabile solo per danni diretti derivanti dall'uso
          del Sito e in ogni caso, essendo gratuito l'accesso ai Servizi, la sua
          responsabilità è limitata alla somma di € 100 (cento euro). Di
          conseguenza, Skeepers declina ogni responsabilità e non può essere
          ritenuta responsabile per qualsiasi danno indiretto, derivante da
          causa esterna al suo Sito, come, senza che l'elenco sia esaustivo:
          dall'uso o dalla ricezione di un Prodotto ricevuto dall'Creator, da o
          in connessione con il Contenuto creato dall'Creator, derivanti da o
          nell’ambito della messa in relazione tra Cliente e Creator, ecc.
        </p>
        <p>
          Skeepers ricorda agli Utenti gli eventuali obblighi fiscali (IVA,
          imposte, ecc.) e sociali (contributi ecc.) relativi alle attività di
          cui sono pienamente responsabili. Le misure da adottare per
          conformarsi ai requisiti legislativi e regolamentari al riguardo, che
          dipendono da criteri diversi a seconda del caso particolare del
          Creator.
        </p>
        <p>
          Oltre alle garanzie fornite nel presente documento, l'Creator
          garantisce Skeepers contro qualsiasi reclamo, denuncia, azione e / o
          rivendicazione di ogni tipo che Skeepers possa subire a seguito della
          violazione da parte del Creator di uno qualsiasi degli obblighi o
          garanzie ai sensi dei presenti Termini e Condizioni. Lo stesso si
          impegna a risarcire Skeepers per qualsiasi danno e a pagarle tutti i
          costi, le accuse e/o le condanne che potrebbe dover sostenere di
          conseguenza.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          15. Accettazione delle Condizioni d'uso dei social network
        </p>
        <p>
          Skeepers utilizza l'API di Youtube in particolare per autenticare e
          collegare il canale Youtube del Creator al suo profilo sul Sito. Di
          conseguenza, utilizzando il Sito, l'Creator accetta espressamente le
          condizioni di utilizzo di Youtube disponibili al seguente indirizzo
          URL:{' '}
          <a
            href="https://www.youtube.com/t/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.youtube.com/t/terms
          </a>
        </p>
        <p>
          Allo stesso modo, l'Creator si impegna ad accettare e rispettare i
          termini di utilizzo di ciascun Social Network che utilizza per
          pubblicare Contenuti.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">16. Disposizioni diverse</p>
        <p>
          Skeepers si riserva il diritto di modificare i presenti T&C in
          qualsiasi momento. Un messaggio pop-up sul Sito informerà gli Utenti
          dell'aggiornamento di tali Condizioni Generali di Utilizzo. Si
          raccomanda all'Creator di leggere regolarmente le T&C.
        </p>
        <p>
          La nullità di tutte o parte di una delle disposizioni dei presenti T&C
          non comporta la nullità delle altre disposizioni.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">17. Adesione</p>
        <p>
          L'accettazione delle presenti condizioni generali si concretizza in
          una casella di controllo nel modulo di registrazione proposta
          all'Creator al momento della registrazione sul Sito tramite un link
          URL. Tale accettazione è senza riserve. Inoltre, i T&C sono
          disponibili in qualsiasi momento sul Sito.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">18. Diritto applicabile</p>
        <p>
          Il Sito e le CGU sono soggetti al diritto francese. Qualsiasi
          controversia relativa all'interpretazione o all'esecuzione dei
          presenti T&C sarà soggetta alla giurisdizione dei tribunali di
          Marsiglia.
        </p>
      </div>
    </>
  )
}

export default ConditionsForContributorsIT
